export const findUniqueKeywords = (values, key) => {
  const seen = new Map();
  return values.filter(item => {
    const lowerKeyword = item?.[key].toLowerCase();
    if (seen.has(lowerKeyword)) return false;
    seen.set(lowerKeyword, item);
    return true;
  });
};
